import React, {Fragment} from 'react';
import List from '../form/list';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import CommercialContractForm from './forms/CommercialContractForm';
import CommercialContractList from './lists/CommercialContractList';

class CommercialContractEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

	render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Form = this.props.formType || CommercialContractForm;
		return (
            <Fragment>
				<List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Partner kedvezmények"}
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <CommercialContractList
                        ref={(el) => this.list = el}
                        {...this.props}
                        loadForm={this.loadForm}
                    />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={this.props.header || "Kedvezmény szerkesztése"}
                    footer={[
                        <Button
                            key="0"
                            type="button"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>/*,
                        <Button key="1" disabled={!this.props.values[this.props.componentConfig.idfield]}
                                color="danger"
                                className="pull-left"
                                onClick={this.props.deleteForm}>
                            Törlés
                        </Button>*/
                    ]}
                >
                    <Form {...this.props} />
                </Editor>
			</Fragment>
		);
	}
}

export default createEditor({componentName: "CommercialContract", WrappedComponent: CommercialContractEditor});